import React, { useEffect } from 'react';
import './FacebookMessenger.css';

const FacebookMessenger = () => {
  useEffect(() => {
    // Initialize Facebook SDK
    window.fbAsyncInit = function() {
      if (window.FB) {
        window.FB.init({
          xfbml: true,
          version: 'v18.0'
        });
      }
    };

    // Load Facebook SDK
    (function(d, s, id) {
      var js, fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) return;
      js = d.createElement(s);
      js.id = id;
      js.src = 'https://connect.facebook.net/en_US/sdk/xfbml.customerchat.js';
      fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'facebook-jssdk'));
  }, []);

  return (
    <>
      <div id="fb-root"></div>
      {/* Facebook Messenger Chat Plugin */}
      <div 
        className="fb-customerchat"
        attribution="biz_inbox"
        page_id="541212399082191"
        theme_color="#8B5CF6"
        logged_in_greeting="Hi! How can we help transform your business today?"
        logged_out_greeting="Hi! How can we help transform your business today?"
      ></div>
    </>
  );
};

export default FacebookMessenger;
